<!--
  Component: Field Calculation Modal: Concatenation Panel.
  Path:      Field - Calculation - Concatenation.
-->
<template>
  <div>
    <div class="fields-header mb-3 ">
      <b-button
        id="addConcatenationValueButton"
        size="sm"
        @click="addConcatenationValue"
      >
        <font-awesome-icon :icon="['fas', 'plus']" />
        Add Concatenation value
      </b-button>
    </div>
    <table class="table-fields w-100">
      <thead>
        <tr class="fields font-weight-bold text-nowrap">
          <!-- Drag Handle column. -->
          <td style="min-width: 46px;" />
          <!-- Concatenation Item properties column. -->
          <td class="pb-2" style="width: 100%;">
            <div class="row">
              <div class="col-sm-4">
                Item Type<span class="text-danger">&nbsp;*</span>
              </div>
              <div class="col-sm-8">
                Item Value<span class="text-danger">&nbsp;*</span>
              </div>
            </div>
          </td>
          <!-- Actions column. -->
          <td class="col-sm-2 text-center" style="min-width: 78px;">
            Actions
          </td>
        </tr>
      </thead>
      <draggable
        v-if="calculationData"
        tag="tbody"
        :list="calculationData.values"
        handle=".handle"
      >
        <concatenation-item
          v-for="(concatenationValue, index) in calculationData.values"
          :key="index"
          :index="index"
          :concatenation-value="concatenationValue"
          @delete-concatenation-value="onDeleteConcatenationValue"
        />
      </draggable>
    </table>
  </div>
</template>

<script>

  import ConcatenationItem from './ConcatenationItem.vue';
  import draggable from 'vuedraggable';

  export default {

    name: 'ConcatenationPanel',

    components: {
      draggable,
      ConcatenationItem,
    },

    inject: [
      /* Current Table. [from CalculationModel] */
      'table',
      /* Current Field. [from CalculationModel] */
      'tableField',
      /* Calculation data - to be populated with Concatenation Values. [from CalculationModel] */
      'calculationData',
    /* Entity utility functions etc. [from CalculationModel] */
    'entityUtils',
    ],

    props: [ 'table' ],

    data() {
      return {
      };
    },

    computed: {
    },

    methods: {
      /** Add a Concatenation Item to the list. */
      addConcatenationValue() {
        /* Ensure Calculation Data has complete set of reactive properties. */
        if (!this.calculationData.values)
          this.$set(this.calculationData, 'values', []);
        /* Add a Concatenation Item to the Calculation Data. */
        this.calculationData.values.push({
          itemType: this.entityUtils.concatenationTypes.stringLiteral,
          itemValue: '',
        });
      },
      /** Delete a Concatenation Item from the list. */
      /** @param {number} index of the Concatenation Item to delete. */
      onDeleteConcatenationValue(index) {
        this.calculationData.values = this.calculationData.values.filter((el, idx) => idx !== index);
      },
    },

  /** Component's Reactive State is initialised but DOM not yet rendered. */
  beforeMount() {
      /* Ensure that at least one Concatenation Item in the list. */
      if (!this.calculationData.values?.length)
        this.addConcatenationValue();
    },
  };

</script>
